let maxDistance = 10;

export function getClosestPointIfAny(lines, x, y) {
    for (let i in lines) {
        let line = lines[i];
        if (distance(x, y, line.x1, line.y1) < maxDistance) {
            return {
                x: line.x1,
                y: line.y1
            };
        } else if (distance(x, y, line.x2, line.y2) < maxDistance) {
            return {
                x: line.x2,
                y: line.y2
            };
        }
    }

    return {
        x,
        y
    };
}

function distance(x1, y1, x2, y2) {
    let d = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    return d;
}
